module.exports = __webpack_public_path__ + "img/icon08.12934cbf.png";